import Api from "../../utils/axios";

const earningApis = {
    getAllOrdersEarning: (payload,search="") => Api.post(`order/get-all-earning?search=${search}`,payload), 
    getAllFoodOrdersEarning: (payload,search="") => Api.post(`food-order/get-all-earning?search=${search}`,payload), 
    getAllVendorStats: (payload,search="") => Api.post(`order/get-all-vendor-stats?search=${search}`,payload),
    getVendorProductEarnings: (payload,search="") => Api.post(`order/get-vendor-product-earnings?search=${search}`,payload),

    createVendorPayout: (payload) =>Api.post('vendor/create-vendor-payout', payload),
    getVendorPayouts: (payload) =>Api.post('vendor/get-vendor-payouts', payload),
    getVendorPayoutById: (payload) =>Api.post('vendor/get-vendor-payout-by-id', payload),

    createDeliverymanPayout: (payload) =>Api.post('deliveryman/create-delivery-man-payout', payload),
    getDeliverymanPayouts: (payload) =>Api.post('deliveryman/get-delivery-man-payouts', payload),
    getDeliverymanPayoutById: (payload) =>Api.post('deliveryman/get-delivery-man-payout-by-id', payload),
    

};

export default earningApis;
